import { nursingRegulators } from "./regulators/nursing";
import { physicianRegulators } from "./regulators/physicians";
import { pharmacyRegulators } from "./regulators/pharmacy";
import { dentistryRegulators } from "./regulators/dentistry";
import { laboratoryRegulators } from "./regulators/laboratory";
import { imagingRegulators } from "./regulators/imaging";
import { rehabilitationRegulators } from "./regulators/rehabilitation";
import { respiratoryRegulators } from "./regulators/respiratory";
import { socialWorkRegulators } from "./regulators/socialWork";
import { dietitianRegulators } from "./regulators/dietitians";

const regulatorGroups = {
  nursingRegulators,
  physicianRegulators,
  pharmacyRegulators,
  dentistryRegulators,
  laboratoryRegulators,
  imagingRegulators,
  rehabilitationRegulators,
  respiratoryRegulators,
  socialWorkRegulators,
  dietitianRegulators,
};

export const regulators = Object.entries(regulatorGroups).reduce(
  (combinedRegulators, [groupName, regulatorGroup]) => {
    if (!regulatorGroup) {
      console.error(
        `${groupName} is undefined. Check the export name in its regulator file.`
      );

      return combinedRegulators;
    }

    Object.entries(regulatorGroup).forEach(
      ([province, professionRegulators]) => {
        combinedRegulators[province] = {
          ...(combinedRegulators[province] || {}),
          ...professionRegulators,
        };
      }
    );

    return combinedRegulators;
  },
  {}
);

export const getRegulator = (province, profession) => {
  return regulators[province]?.[profession] || "";
};